import React, { useState } from 'react';
import TicketButton, { TicketButtonTypes } from '../TicketButton';
import ModalOnHoldTickets from './ModalMergeTickets';
import { cashierCtrl } from 'modules/POS/Cashier/cashier.controller';

const MergeTicket = () => {
  const [open, setOpen] = useState(false);
  const onClose = () => setOpen(false);
  const onOpen = () => setOpen(true);
  const onComplete = (billId: string) => cashierCtrl.switchTicket(billId);
  return (
    <>
      <TicketButton
        type={TicketButtonTypes.MERGE_TICKET}
        onClick={onOpen}
      />
      <ModalOnHoldTickets
        open={open}
        onClose={onClose}
        onComplete={onComplete}
      />
    </>
  );
};

export default MergeTicket;
